<template>
  <div class="chat-footer">
    <div class="footer-more flex">
      <div class="flex-1 privacy">
        <shield-icon />
        <a
          :href="privacyPolicy"
          target="_blank"
        >Privacy policy</a>
      </div>
      <div class="flex-1 powered">
        <span>Powered</span>
        <bot-icon />
        <span>by</span>
        <a v-if="chatchampLinkClickable" :href="poweredByURL" class="footer-more__powered-by-link" target="_blank">trbo</a>
        <span v-if="!chatchampLinkClickable">trbo</span>
      </div>
    </div>
  </div>
</template>

<script>
// @flow

import { poweredByURL } from '../../../common/models'

import BotIcon from './BotIcon.vue'
import ShieldIcon from './ShieldIcon.vue'

export default {
  components: {
    BotIcon,
    ShieldIcon
  },
  props: {
    customerId: {
      type: String,
      required: true
    },
    privacyPolicy: {
      type: String,
      required: true
    },
    chatchampLinkClickable: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    poweredByURL (): string {
      return poweredByURL('Chatbot')
    }
  }
}
</script>

<style src="./chat-footer.scss" />
